import React from "react";
import PricingTable from "./PricingTable";
import BoldCell from "./BoldCell";
import { css } from "@emotion/react";
import { mediaQueries, pxToRem } from "@upsun/react-component-library/src/styles/css-utils";
import { pricingInfo } from "../../data/pricing-page-data";

type UserLicensesTableProps = {
  currency: string;
};

const UserLicensesTable: React.FC<UserLicensesTableProps> = ({
  currency,
  ...props
}) => {
  const noMargin = css`
    margin-bottom: 0;
  `;

  const borderLeft = css`
    ${mediaQueries.md} {
      border-left: ${pxToRem(1)} solid #646f75;
    }
  `;

  const onlyMobile = css`
    display: table-cell;

    ${mediaQueries.md} {
      display: none !important;
    }
  `;

  const hideOnMobile = css`
    display: none;

    ${mediaQueries.md} {
      display: table-cell;
      position: relative;
      left: ${pxToRem(-1)};
    }
  `;

  const hideTopOnMobile = css`
    border-top: none !important;

    ${mediaQueries.md} {
      border-top: ${pxToRem(1)} solid rgb(100, 111, 117);
    }
  `;

  const marginTopOnMobile = css`
    margin-top: ${pxToRem(16)};

    ${mediaQueries.md} {
      margin-top: 0;
    }
  `;

  const singleSignOnDisclaimer = css`
    margin-bottom: 0;
    font-weight: 400;
    font-size: ${pxToRem(13)};
  `;

  return (
    <PricingTable>
      <tbody>
        <tr>
          <BoldCell>User license</BoldCell>
          <td>{pricingInfo.userLicense[currency]}/user/month</td>
        </tr>
        <tr>
          <BoldCell>Teams management</BoldCell>
          <td rowSpan={3} css={[borderLeft, hideOnMobile]}>
            With <strong>Advanced user management</strong> at +{pricingInfo.userManagementFee[currency]}/user/month
          </td>
        </tr>
        <tr css={hideTopOnMobile}>
          <BoldCell>MFA enforcement</BoldCell>
        </tr>
        <tr css={hideTopOnMobile}>
          <BoldCell>
            <p css={noMargin}><strong>Single sign-on: Google, OIDC (Microsoft Entra ID, Okta, PingID, Ory)</strong></p>
            <p css={singleSignOnDisclaimer}><a href="https://auth.upsun.com">Contact support to enable</a></p>
          </BoldCell>
          <td css={[onlyMobile, marginTopOnMobile]}>
            With <strong>Advanced user management</strong> at +{pricingInfo.userManagementFee[currency]}/user/month
          </td>
        </tr>
      </tbody>
    </PricingTable>
  );
};

export default UserLicensesTable;
